<motif-form-field>
  <motif-select
    class="pagination-select"
    [ngModel]="selectedOption().id"
    (selectionChange)="onSelectionChange($event)"
    [sortComparator]="sortComparator"
    labelPosition="outside">
    @for (option of options(); track option) {
      <motif-option [value]="option.id">
        {{ getOptionLabel(option) }}
      </motif-option>
    }
  </motif-select>
</motif-form-field>
